export default __webpack_public_path__ + "static/media/ic_chevron_down.f7e03f2d.svg";